(function () {
  'use strict';

  var scheduled = false;

  function fixStampedAria() {
    /*
     * Stamped puts aria-label on .stamped-badge <span> elements.
     * Give the visual star rating a valid semantic role.
     */
    document
      .querySelectorAll('.stamped-badge[aria-label]')
      .forEach(function (badge) {
        if (badge.getAttribute('role') !== 'img') {
          badge.setAttribute('role', 'img');
        }
      });

    /*
     * The review-count caption already contains visible text, so its
     * aria-label is redundant and invalid on a plain span.
     */
    document
      .querySelectorAll('.stamped-badge-caption[aria-label]')
      .forEach(function (caption) {
        caption.removeAttribute('aria-label');
      });

    /*
     * Stamped marks displayed review stars as role="list" even though
     * the star icons are not role="listitem". Treat the complete star
     * rating as one labelled graphic instead.
     */
    document
      .querySelectorAll('.stamped-review-header-starratings[role="list"][aria-label]')
      .forEach(function (stars) {
        stars.setAttribute('role', 'img');
      });


/*
 * Stamped rating bars may be interactive review filters.
 * Keep buttons accessible and give them a readable name.
 * Hide only non-interactive, decorative bars.
 */
document.querySelectorAll('.summary-rating-bar').forEach(function (bar) {
  var isInteractive =
    bar.getAttribute('role') === 'button' ||
    bar.hasAttribute('tabindex') ||
    bar.querySelector('a, button, [tabindex]');

  if (isInteractive) {
    bar.removeAttribute('aria-hidden');

    if (
      bar.getAttribute('role') === 'button' &&
      !bar.getAttribute('aria-label')
    ) {
      var rating = bar.getAttribute('data-rating');

      if (rating) {
        bar.setAttribute('aria-label', rating + '-star reviews');
      }
    }
  } else {
    bar.removeAttribute('aria-label');

    if (bar.getAttribute('aria-hidden') !== 'true') {
      bar.setAttribute('aria-hidden', 'true');
    }
  }
});
  }

  function scheduleFix() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(function () {
      scheduled = false;
      fixStampedAria();
    });
  }

  function init() {
    fixStampedAria();

    /*
     * Stamped loads and re-renders asynchronously, so keep correcting
     * newly injected or reset markup.
     */
    var observer = new MutationObserver(scheduleFix);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'aria-hidden', 'class', 'role', 'tabindex']
    });

    /* Extra passes for Stamped's delayed initial rendering. */
    [250, 500, 1000, 2000, 4000].forEach(function (delay) {
      setTimeout(fixStampedAria, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();